import Vue from 'vue';
import MessageBox from 'element-ui/lib/message-box';
// eslint-disable-next-line
import css from './message-box.scss';

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

/* eslint-disable */
// Seems weird. exporting as default causes an error in bundled js file.
export { MessageBox };
